// import "./BaselineReport.scss";
import { AnnualCumulativePicker } from "components/organisms/Charts";
import { RadioButtonSelectMode } from "components/organisms/Charts/AnnualCumulativePicker";
import { useState } from "react";
import { CURRENT_YEAR } from "utils/constants";
import { ReportsCumulativeOperatingCostCard } from "components/organisms/Charts/Recommendations/CumulativeOperatingCostCard";
import CumulativeCarbonEmissionsCard from "./CumulativeCarbonEmissionsCard";
import CumulativeEnergyConsumptionCard from "./CumulativeEnergyConsumptionCard";
import AnnualCarbonEmissionsCard from "./AnnualCarbonEmissionsCard";
import AnnualEnergyConsumptionCard from "./AnnualEnergyConsumptionCard";

function FutureProjectionCards({
    filtersetUid,
    reportedVsPublished,
}: {
    filtersetUid: string;
    reportedVsPublished: string;
}) {
    const [selected, setSelected] = useState<RadioButtonSelectMode>("cumulative");
    const [sliderCurrentYear, setSliderCurrentYear] = useState(CURRENT_YEAR);

    const onChangeSelect = () => {
        setSelected((prev) => {
            if (prev === "cumulative") return "annual";
            return "cumulative";
        });
    };

    return (
        <div>
            <AnnualCumulativePicker
                selected={selected}
                onChangeSelect={onChangeSelect}
                currentSliderYear={sliderCurrentYear}
                setCurrentSliderYear={setSliderCurrentYear}
            />
            <div className="cards">
                {selected === "cumulative" ? (
                    <>
                        <CumulativeCarbonEmissionsCard filtersetUid={filtersetUid} />
                        <CumulativeEnergyConsumptionCard filtersetUid={filtersetUid} />
                        <ReportsCumulativeOperatingCostCard
                            filtersetUid={filtersetUid}
                            reportedVsPublished={reportedVsPublished}
                            isBaseline={true}
                            year={null}
                        />
                    </>
                ) : (
                    <>
                        <AnnualCarbonEmissionsCard selectedYear={sliderCurrentYear} filtersetUid={filtersetUid} />
                        <AnnualEnergyConsumptionCard selectedYear={sliderCurrentYear} filtersetUid={filtersetUid} />
                        <ReportsCumulativeOperatingCostCard
                            filtersetUid={filtersetUid}
                            reportedVsPublished={reportedVsPublished}
                            isBaseline={true}
                            year={sliderCurrentYear}
                        />
                    </>
                )}
            </div>
        </div>
    );
}

export default FutureProjectionCards;
